import { render, staticRenderFns } from "./PermitActivity.vue?vue&type=template&id=94d9d07e"
import script from "./PermitActivity.vue?vue&type=script&lang=js"
export * from "./PermitActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports